import type { ReactElement, SVGProps } from "react";

export function SmartMembershipIcon(
  props: SVGProps<SVGSVGElement>,
): ReactElement {
  return (
    <svg
      width="47"
      height="16"
      viewBox="0 0 47 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 8C0 3.58172 3.58172 0 8 0H38.64C43.0583 0 46.64 3.58172 46.64 8C46.64 12.4183 43.0583 16 38.64 16H8C3.58172 16 0 12.4183 0 8Z"
        fill="url(#paint0_radial_2219_45894)"
      />
      <path
        d="M10.7003 11.4178C10.2855 11.4178 9.89434 11.3438 9.52694 11.1956C9.16545 11.0415 8.85138 10.8252 8.58471 10.5467C8.32397 10.2682 8.12842 9.93931 7.99805 9.56005L9.12694 9.05339C9.29286 9.41487 9.52101 9.69931 9.81138 9.90672C10.1077 10.1141 10.4336 10.2178 10.7892 10.2178C10.9788 10.2178 11.1418 10.1882 11.278 10.1289C11.4143 10.0697 11.521 9.98968 11.598 9.88894C11.6751 9.78228 11.7136 9.65783 11.7136 9.51561C11.7136 9.36153 11.6662 9.23116 11.5714 9.1245C11.4766 9.0119 11.3284 8.92302 11.1269 8.85783L9.82916 8.43116C9.30175 8.25931 8.90471 8.01635 8.63805 7.70228C8.37138 7.38228 8.23805 7.00005 8.23805 6.55561C8.23805 6.1645 8.33286 5.82079 8.52249 5.5245C8.71805 5.2282 8.98768 4.99709 9.33138 4.83116C9.68101 4.66524 10.081 4.58228 10.5314 4.58228C10.9284 4.58228 11.2958 4.65042 11.6336 4.78672C11.9714 4.92302 12.2618 5.11561 12.5047 5.3645C12.7536 5.61339 12.9403 5.91265 13.0647 6.26228L11.9447 6.76894C11.8203 6.46079 11.6336 6.22079 11.3847 6.04894C11.1358 5.87116 10.8514 5.78228 10.5314 5.78228C10.3477 5.78228 10.1847 5.8119 10.0425 5.87116C9.90027 5.93042 9.79064 6.01635 9.7136 6.12894C9.63657 6.23561 9.59805 6.36005 9.59805 6.50228C9.59805 6.65635 9.64842 6.79265 9.74916 6.91116C9.8499 7.02376 10.001 7.11265 10.2025 7.17783L11.4736 7.58672C12.0069 7.75857 12.404 7.99857 12.6647 8.30672C12.9314 8.61487 13.0647 8.99116 13.0647 9.43561C13.0647 9.82079 12.964 10.1645 12.7625 10.4667C12.561 10.763 12.2825 10.9971 11.9269 11.1689C11.5773 11.3349 11.1684 11.4178 10.7003 11.4178Z"
        fill="#FAE5F3"
      />
      <path
        d="M14.0466 11.3112V4.68894H15.3799L17.8599 7.97783H17.2377L19.6466 4.68894H20.9799V11.3112H19.6021V6.20894L20.1533 6.33339L17.6021 9.62227H17.4244L14.9621 6.33339L15.4244 6.20894V11.3112H14.0466Z"
        fill="#FAE5F3"
      />
      <path
        d="M21.6653 11.3112L23.9053 4.68894H25.7365L27.9764 11.3112H26.4742L26.0298 9.96005H23.6031L23.1587 11.3112H21.6653ZM23.9853 8.76005H25.6476L24.6342 5.63116H25.0076L23.9853 8.76005Z"
        fill="#FAE5F3"
      />
      <path
        d="M28.6646 11.3112V4.68894H31.198C31.6543 4.68894 32.0572 4.76894 32.4069 4.92894C32.7624 5.08894 33.0409 5.32598 33.2424 5.64005C33.4439 5.95413 33.5446 6.34228 33.5446 6.8045C33.5446 7.25487 33.4409 7.64005 33.2335 7.96005C33.0261 8.27413 32.7476 8.51116 32.398 8.67116L33.9091 11.3112H32.3624L30.7269 8.38672L31.6158 8.91116H30.0424V11.3112H28.6646ZM30.0424 7.71116H31.2069C31.4024 7.71116 31.5713 7.67265 31.7135 7.59561C31.8558 7.51857 31.9654 7.4119 32.0424 7.27561C32.1254 7.13931 32.1669 6.98228 32.1669 6.8045C32.1669 6.62079 32.1254 6.46079 32.0424 6.3245C31.9654 6.1882 31.8558 6.08153 31.7135 6.0045C31.5713 5.92746 31.4024 5.88894 31.2069 5.88894H30.0424V7.71116Z"
        fill="#FAE5F3"
      />
      <path
        d="M35.611 11.3112V5.88894H33.931V4.68894H38.6421V5.88894H36.9887V11.3112H35.611Z"
        fill="#FAE5F3"
      />
      <defs>
        <radialGradient
          id="paint0_radial_2219_45894"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(42.1812 33.9514 -99.5722 119.932 2.1559 -16.2963)"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4B0A74" />
          <stop offset="0.384615" stopColor="#7C25B8" />
          <stop offset="0.673077" stopColor="#9600F1" />
          <stop offset="1" stopColor="#FA3AAB" />
        </radialGradient>
      </defs>
    </svg>
  );
}
